import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MaterialPageGrid } from '../../../utils/material-page-grid';
import { ResearchPortalBdService } from '../../../services/research-portal-bd.service';

@Component({
  selector: 'app-sector-valuation-metrics',
  templateUrl: './sector-valuation-metrics.component.html',
  styleUrls: ['./sector-valuation-metrics.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SectorValuationMetricsComponent implements OnInit {
  loadingData = false;
  sectorQuarterDates = [];
  dateSelector = new FormControl('');
  gridData = [];
  columns = [
    { id: 2, colOptional: true, label: 'Ticker', selected: true, field: 'ticker', type: '' },
    { id: 3, colOptional: true, label: 'EBIT Margin', selected: true, field: 'ebitMargin', type: 'money' },
    { id: 4, colOptional: true, label: 'EV/Sales (x)', selected: true, field: 'evToSales', type: 'number' },
    {
      id: 5,
      colOptional: true,
      label: 'EV/EBIT (x)',
      selected: true,
      field: 'eveToEbit',
      type: 'number',
    },
    { id: 6, colOptional: true, label: 'Gross Margin (%)', selected: true, field: 'grossMargin', type: 'number' },
    { id: 7, colOptional: true, label: 'NPAT (YoY)', selected: true, field: 'napt', type: 'number' },
    { id: 8, colOptional: true, label: 'Net Profit Margin (TTM)', selected: true, field: 'netProfitMargin', type: 'money' },
    { id: 9, colOptional: true, label: 'P/B (x)', selected: true, field: 'priceToBookValue', type: 'number' },
    { id: 10, colOptional: true, label: 'P/E (x)', selected: true, field: 'priceToEarnings', type: 'number' },
    { id: 11, colOptional: true, label: 'P/S (x)', selected: true, field: 'priceToSales', type: 'number' },
    { id: 12, colOptional: true, label: 'Rev. growth (YoY)', selected: true, field: 'revenueGrowth', type: 'number' },
    { id: 13, colOptional: true, label: 'ROE (%)', selected: true, field: 'roe', type: 'number' },
    { id: 14, colOptional: true, label: 'ROIC (%)', selected: true, field: 'roic', type: 'money' },
  ];

  constructor(private researchPortalBd: ResearchPortalBdService, private cdRef: ChangeDetectorRef, private fb: FormBuilder) {}

  async ngOnInit() {
    this.loadingData = true;
    this.cdRef.detectChanges();
    let data = await this.researchPortalBd.getSectorQuarterDates();
    this.sectorQuarterDates = data;
    this.dateSelector.setValue(data[0]);
    await this.getSectorQuarterByDate();
    this.cdRef.detectChanges();
    this.dateSelector.valueChanges.subscribe(async () => {
      this.gridData = [];
      this.loadingData = true;
      this.cdRef.detectChanges();
      await this.getSectorQuarterByDate();
    });
  }

  async getSectorQuarterByDate() {
    let data = await this.researchPortalBd.getSectorValuationMetricsData(this.dateSelector.value);
    await this.gridDataSettings(data);
  }

  async gridDataSettings(data) {
    this.gridData = [];
    this.cdRef.detectChanges();
    for (const sector of data) {
      let keys = Object.keys(sector.companies[0]);
      let grid = new MaterialPageGrid(this.fb, 10);
      grid.setSource(async (query) => {
        // query: { pageIndex, pageSize, sortActive, sortDirection, filterValues }
        let start = query.pageIndex * query.pageSize;
        let end = start + query.pageSize;
        let sorted = [...sector.companies];
        if (query.sortActive && query.sortDirection) {
          sorted.sort((a, b) => {
            if (a[query.sortActive] < b[query.sortActive]) return query.sortDirection === 'asc' ? -1 : 1;
            if (a[query.sortActive] > b[query.sortActive]) return query.sortDirection === 'asc' ? 1 : -1;
            return 0;
          });
        }
        // Filtering can be added here if needed
        return { data: sorted.slice(start, end), total: sector.companies.length };
      });
      grid.setTableColumns(this.columns.filter((sec) => keys.find((k) => sec.field === k)).map((col) => col.field));
      grid.gridColumns = this.columns.filter((sec) => keys.find((k) => sec.field === k));
      const finalEachSectorData = {
        gridData: grid,
        gridName: sector.name,
        ebitMarginSum: sector.ebitMarginSum,
        evToSalesSum: sector.evToSalesSum,
        eveToEbitSum: sector.eveToEbitSum,
        grossMarginSum: sector.grossMarginSum,
        priceToBookValueSum: sector.priceToBookValueSum,
        priceToEarningsSum: sector.priceToEarningsSum,
        priceToSalesSum: sector.priceToSalesSum,
        roeSum: sector.roeSum,
        gridColumns: grid.gridColumns,
        displayedColumns: grid.displayedColumns,
      };
      this.gridData.push(finalEachSectorData);
      this.cdRef.detectChanges();
    }
    this.loadingData = false;
    this.cdRef.detectChanges();
  }
}
